(() => {
  if (customElements.get('omega3-faq-accordion')) return;

  class Omega3FaqAccordion extends HTMLElement {
    constructor() {
      super();
      this.onClick = this.onClick.bind(this);
    }

    connectedCallback() {
      this.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
    }

    onClick(event) {
      const trigger = event.target.closest('[data-omega3-faq-toggle]');
      if (!trigger || !this.contains(trigger)) return;

      const item = trigger.closest('[data-omega3-faq-item]');
      if (!item) return;

      const wasOpen = item.classList.contains('is-open');

      this.querySelectorAll('[data-omega3-faq-item].is-open').forEach((openItem) => {
        openItem.classList.remove('is-open');
        openItem.querySelector('[data-omega3-faq-toggle]')?.setAttribute('aria-expanded', 'false');
      });

      if (!wasOpen) {
        item.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
      }
    }
  }

  customElements.define('omega3-faq-accordion', Omega3FaqAccordion);
})();
